import React, { FC } from 'react';


interface MessageTextDisplayComponentProps{
    description?: string;
    title?: string;
    body: string | Array<string>;
}
const MessageTextDisplayComponent: FC<MessageTextDisplayComponentProps> = ({description, title, body}) => {
    
return (
    <React.Fragment>
        {title? <h2>{title}</h2>: <></>}
        {description? <h3>{description}</h3>: <></>}
        <div style={{ display: 'block', position: 'relative' }}>
        <div style={{ position: 'absolute', margin: 'auto', left: 0, right: 0, top: '150px', width: '90%', textAlign: 'center' }}>
            <p style={{ fontSize: '20px', lineHeight: '28px', border: 'dashed 3px #ccc', padding: '30px', color: '#333' }}>
            {Array.isArray(body) ? body.map((text)=>(<><p>{text}</p></>)): <p>{body}</p>} 
            </p>
        </div>
        </div>
    </React.Fragment>
  );
};

export default MessageTextDisplayComponent;
